import type { IntlShape } from "react-intl";

export const CLEAR_SORT_OPTION_ID = 'CLEAR_SORT';

export const getSortOptionsSupport = (intl: IntlShape) => [
    { id: 'HEADER', label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.createdTime" }), header: true },
    {
        id: 'CREATED_ASC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.oldestFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    {
        id: 'CREATED_DESC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.newestFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    { id: 'HEADER', label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.stepTime" }), header: true },
    {
        id: 'STATUS_UPDATED_AT_DESC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.shortestTimeFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    {
        id: 'STATUS_UPDATED_AT_ASC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.longestTimeFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    { id: 'HEADER', label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.updatedAt" }), header: true },
    {
        id: 'UPDATED_AT_ASC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.oldestFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    {
        id: 'UPDATED_AT_DESC',
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.newestFirst" }),
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    { id: 'HEADER', label: '__________________________', header: true },
    {
        id: CLEAR_SORT_OPTION_ID,
        label: intl.formatMessage({ id: "intl-msg:tas.support.toolbar.sort.clearSort" }),
        icon: <span className='rioglyph rioglyph-trash' />,
    },
];

const SORT_BY_TO_API: Record<string, string> = {
    CREATED: 'createdAt',
    UPDATED_AT: 'updatedAt',
    STATUS_UPDATED_AT: 'statusUpdatedAt',
};

const SORT_BY_FROM_API: Record<string, string> = {
    createdAt: 'CREATED',
    updatedAt: 'UPDATED_AT',
    statusUpdatedAt: 'STATUS_UPDATED_AT',
};

export const parseSortOption = (optionId: string) => {
    const lastUnderscore = optionId.lastIndexOf('_');
    const sortByKey = optionId.substring(0, lastUnderscore);
    const sortDirection = optionId.substring(lastUnderscore + 1);

    return {
        sortBy: SORT_BY_TO_API[sortByKey] ?? sortByKey,
        sortDirection,
    };
};

export const getSortOptionId = (sortBy: string, sortDirection: string) => {
    if (!sortBy || !sortDirection) return '';
    const sortByKey = SORT_BY_FROM_API[sortBy] ?? sortBy;
    return `${sortByKey}_${sortDirection}`;
};
